import React, { useState, useContext, useEffect } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';

import { CreateEmployeeModal } from './Modal_CreateEmployee';
import { GrantEmployeeAccessModal } from './Modal_GrantEmployeeAccess';
import { DeleteEmployeeModal } from './Modal_DeleteEmployee';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { ManageEmployeeModal } from './Modal_ManageEmployee';

import '../../../css/layout.css';

export function  Tab_Management_Employee () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [createEmployeeModal, setCreateEmployeeModal] = useState(false);
    let [manageEmployeeModal, setManageEmployeeModal] = useState(false);
    let [grantEmployeeAccessModal, setGrantEmployeeAccessModal] = useState(false);
    let [deleteEmployeeModal, setDeleteEmployeeModal] = useState(false);
    let [viewEmployeeList, setViewEmployeeList] = useState([]);


    useEffect(() => {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {'content-type': 'application/json' },
            body: JSON.stringify({
                Tracker: '74503_employeeList',
                user: acctID,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewEmployeeList((prevViewEmployeeList) => {
                    return prevViewEmployeeList.concat({
                        employeeID: cols[0],
                        employeeName: cols[1],
                        dateHired: cols[2],
                        biWeeklyPay: parseFloat(cols[3]).toFixed(2),
                        jobFunction: cols[4],
                        phoneNumber: cols[5],
                        emailAddress: cols[6],
                        employeeSchema: cols[7],
                    })
                });
            } 
        })

    }, [])    
    
    function addEmployeePay_Manual() 
    {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: '74800_add_payStubs',
                user: acctID,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

        })
    }
        
    // alert('In Employee ');
    // alert(authenticatedMerchent_context.selectedTutorial?.details?.tutorial_id);
    // alert(authenticatedMerchent_context.selectedTutorial?.details?.step_1);

    return (
        <React.Fragment>

            <IonItem>
                <IonGrid>
                    <IonRow style={{color: 'black'}}>
                        <IonCol>
                            <h3> Employees </h3>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="6">
                        {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '6'&& authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                        ? <IonButton className='flash-tutorial' onClick={() => setCreateEmployeeModal(true)}>Create</IonButton>
                        : <IonButton onClick={() => setCreateEmployeeModal(true)}>Create</IonButton>}
                        </IonCol>
                        <IonCol size="6">
                        {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '7'&& authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                        ? <IonButton className='flash-tutorial' onClick={() => setDeleteEmployeeModal(true)}>Delete</IonButton>
                        : <IonButton onClick={() => setDeleteEmployeeModal(true)}>Delete</IonButton>}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonItem>

            <IonContent className='grid_content'>
                         {/* Scrollable content below */}
            <div style={{ display: 'inline-block', marginTop: '120px' }}>
            {/* Employee grid and details */}
                        <div style={{display: 'inline-block'}}>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        {(authenticatedMerchent_context.selectedTutorial?.tutorial_id == '8' && authenticatedMerchent_context.selectedTutorial?.details?.step_1 == false) 
                                        ? <IonButton  className='flash-tutorial' onClick={() => addEmployeePay_Manual(true)}>Add Pay Manual All</IonButton>
                                        :<IonButton  onClick={() => addEmployeePay_Manual(true)}>Add Pay Manual All</IonButton>}
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            <IonGrid >
                                <IonRow >
                                        {/*<IonCol size='1'>ID</IonCol>*/}
                                        <IonCol size='2'>Name</IonCol>
                                        {/*<IonCol size='2'>Hire Date</IonCol>*/}
                                        {/*<IonCol size='2'>Bi-weekly Pay</IonCol>*/}
                                        <IonCol size='6'>Role</IonCol>
                                        {/*<IonCol>Phone Number</IonCol>*/}
                                        {/*<IonCol>Email Address</IonCol>*/}
                                        {/*<IonCol>Employee Schema</IonCol>*/}
                                        <IonCol size='4'>Action</IonCol>
                                </IonRow>
                                {viewEmployeeList.map((detailData) =>   {
                                    return (
                                        <IonRow >
                                            {/*<IonCol size='1'>{detailData.employeeID}</IonCol>*/}
                                            <IonCol size='2'>{detailData.employeeName}</IonCol>
                                            {/*<IonCol size='2'>{detailData.dateHired}</IonCol>*/}
                                            {/*<IonCol size='2'>{detailData.biWeeklyPay}</IonCol>*/}
                                            <IonCol size='6'>{detailData.jobFunction}</IonCol>
                                            {/*<IonCol>{detailData.phoneNumber}</IonCol>*/}
                                            {/*<IonCol>{detailData.emailAddress}</IonCol>*/}
                                            {/*<IonCol>{detailData.employeeSchema}</IonCol>*/}
                                            <IonCol size='4'>
                                                {/*<IonButton class='gridResultColumnButton' > Image </IonButton>*/}
                                                <IonButton className='small_button'> Details </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                        </div>

                {/*{grantEmployeeAccessModal == true && <GrantEmployeeAccessModal openModal= { grantEmployeeAccessModal } closeModal={() => setGrantEmployeeAccessModal(false)}></GrantEmployeeAccessModal>}

                {manageEmployeeModal == true && <ManageEmployeeModal openModal= { manageEmployeeModal } closeModal={() => setManageEmployeeModal(false)} ></ManageEmployeeModal>}*/}
                
                {createEmployeeModal == true && <CreateEmployeeModal openModal= { createEmployeeModal } closeModal={() => setCreateEmployeeModal(false)}></CreateEmployeeModal>}

                {deleteEmployeeModal == true && <DeleteEmployeeModal openModal= { deleteEmployeeModal } closeModal={() => setDeleteEmployeeModal(false)}> </DeleteEmployeeModal>}

        </div>
            </IonContent>
            </React.Fragment>

        )
}